// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Admin {\n  text-align: center;\n  width: calc(100vw - 20px);\n  height: calc(100vh - 64px);\n  min-height: calc(100vh - 64px);\n  padding: 0 10px;\n  margin: 64px 0 0 0;\n}", ""]);
// Exports
module.exports = exports;
